var $dc6473b5f88d53d5$exports = {};
$dc6473b5f88d53d5$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Renk Se\xe7ici`,
    "colorSwatch": `renk \xf6rne\u{11F}i`,
    "transparent": `saydam`,
    "twoDimensionalSlider": `2D s\xfcrg\xfc`
};


export {$dc6473b5f88d53d5$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
